import BlTabNavMv from './BlTabNavMv.vue'

BlTabNavMv.install = function(Vue) {
  Vue.component(BlTabNavMv.name, BlTabNavMv)
}

export default BlTabNavMv
